import Container from "react-bootstrap/Container";
import React, { useEffect } from "react";
import PageWrapper from "./PageWrapper";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
export default function FeedBackPage(props) {

    return (
        <PageWrapper>
            <Container style={{ marginTop: 80 }}>
                <Row>
                    <Col style={{ textAlign: "center" }}>
                        <div className="responsive-survey">
                            <iframe
                                width={640}
                                height={1300}
                                src={'https://forms.gle/9Ev54EQrGtmP6Dku8'}
                                frameBorder={0}
                                marginHeight={0}
                                marginWidth={0}
                            >
                                Memuat...
                            </iframe>
                        </div>
                    </Col>

                </Row>

            </Container>
        </PageWrapper>
    )
}
